<div class="page-banner" *ngIf="viewModel.hasBanner$ | async">
  <div class="message">
    <img [src]="'assets/icons/dark/solid/information-circle.svg'" alt="" />
    <div class="message-stack">
      <div
        *ngFor="let row of viewModel.bannerRows$ | async; trackBy: trackByRowId"
        class="message-body"
        [class.is-active]="row.isActive"
        [innerHTML]="row.safeHtml"></div>
    </div>
  </div>
</div>
